// src/components/EventHeader.tsx
import { Box, Typography, Stack, Paper } from "@mui/material";
import { FormatQuote } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";

interface EventHeaderProps {
  userName: string | null;
  eventName: string | null;
  eventDate: Date | null;
  description: string | null;
}

export function EventHeader({
  userName,
  eventName,
  eventDate,
  description,
}: EventHeaderProps) {
  const theme = useTheme();

  const formatEventDate = (date: Date) => {
    return date.toLocaleDateString("en-US", {
      weekday: "long",
      month: "long",
      day: "numeric",
      year: "numeric",
    });
  };

  return (
    <Paper sx={{ p: 4, mb: 3 }}>
      <Typography
        variant="h3"
        component="h1"
        gutterBottom
        color="primary"
        sx={{ textAlign: "center" }}
      >
        Record a Message for {userName || "the Runner"}
      </Typography>

      <Typography
        variant="h6"
        color="text.secondary"
        sx={{ textAlign: "center", mb: 2 }}
      >
        {eventName && eventDate && (
          <>
            Running the <strong>{eventName}</strong> on{" "}
            {formatEventDate(eventDate)}
          </>
        )}
      </Typography>

      {description && (
        <Box
          sx={{
            mt: 3,
            p: 3,
            bgcolor: "background.default",
            borderLeft: `4px solid ${theme.palette.primary.main}`,
            borderRadius: "0 12px 12px 0",
          }}
        >
          <Stack direction="row" spacing={1} alignItems="flex-start">
            <FormatQuote
              sx={{
                color: "primary.main",
                transform: "scaleX(-1)",
                mt: 0.5,
              }}
            />
            <Box>
              <Typography
                variant="body1"
                sx={{
                  fontStyle: "italic",
                  color: "text.primary",
                  lineHeight: 1.6,
                }}
              >
                {description}
              </Typography>
              <Typography
                variant="caption"
                sx={{ mt: 1, display: "block", color: "text.secondary" }}
              >
                {userName || "the runner"}
              </Typography>
            </Box>
          </Stack>
        </Box>
      )}
    </Paper>
  );
}
